export default __webpack_public_path__ + "static/media/pexels-sathesh-d-698808.462a4d04.jpg";